import type { AdminKpisMetricTileProps } from "../../models/admin-kpis.models";
import { memo } from "react";

const AdminKpisMetricTile = ({ metric }: AdminKpisMetricTileProps) => {
  return (
    <div className="min-w-0 border border-[#D7E2DE] bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <div className="truncate text-[11px] font-semibold uppercase text-[#4A5655] dark:text-gray-300">
        {metric.label}
      </div>
      <div className="mt-2 text-2xl font-semibold text-green">{metric.percentage.toFixed(1)}%</div>
      <div className="mt-1 text-xs text-gray-600 dark:text-gray-300">{metric.count} vessels</div>
    </div>
  );
};

export default memo(AdminKpisMetricTile);
